import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { fontSize } from "../../styles";
import useWindowDimensions from "./window-dimensions";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "90%",
    border: "none",
    display: "flex",
    marginTop: 10,
    marginLeft: 20,
    marginBottom: 10,
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      marginLeft: 15,
    },
  },
  text: {
    fontWeight: "bold",
    color: "white",
    flexGrow: 1,
  },
  form: {
    display: "flex",
    alignItems: "center",
    marginBottom: 10,
  },
  dotlabel: {
    fontSize: fontSize.h1,
    marginLeft: 10,
    marginRight: 20,
    color: "#7F7F7F",
    display: "inline-block",
    verticalAlign: "middle",
  },
  subtitle: {
    marginTop: 10,
    marginLeft: 30,
    textTransform: "unset !important",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 15,
    },
  },
  title: {
    marginTop: 10,
    marginLeft: 20,
    [theme.breakpoints.down("xs")]: {
      fontSize: fontSize.h4,
      marginLeft: 15,
    },
    [theme.breakpoints.down("md")]: {
      fontSize: fontSize.h5,
      marginLeft: 15,
    },
  },
  smallerTwo: {
    overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      maxHeight: "70vh",
    },
  },
  highlighterCorrect: {
    minHeight: 48,
    width: "100%",
    padding: "10.5px 14px",
    borderRadius: 4,
    fontSize: 14,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "rgba(0, 0, 0, 0.38)",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#4CC87D",
  },
  highlighterWrong: {
    minHeight: 48,
    width: "100%",
    padding: "10.5px 14px",
    borderRadius: 4,
    fontSize: 14,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "rgba(0, 0, 0, 0.38)",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#FF9999",
  },
}));

export const OutputChecklist = ({
  title,
  isAnswer,
  type, // management / diagnosis
  category, // provisional / differential etc.
}) => {
  const { height } = useWindowDimensions();
  // get contents from the game state by type
  const answers = useSelector((state) => state.gameStates.case[type]);
  const contents = useSelector((state) => state.gameStates[category]);

  const [highlights, setHighlights] = useState([]); // list of options to highlight

  // if is answer and contents change, reset IDs to highlight
  useEffect(() => {
    console.log(contents);
    if (!isAnswer) return;
    const tmp = [];
    contents.forEach((c) => {
      if (!!c.result && !!c.result.id) tmp.push(c.result.id);
    });
    setHighlights(tmp);
  }, [isAnswer, contents]);
  const classes = useStyles();

  // display list of textfield
  const display = () => {
    return (
      <>
        <Typography variant="h3" className={classes.subtitle}>
          {title}
        </Typography>
        <div className={classes.container}>
          <div
            className={classes.smallerTwo}
            style={{
              maxHeight: height - 360,
            }}
          >
            {isAnswer ? (
              <>
                {_.filter(answers, (answer) => {
                  return answer.type === category;
                }).length > 0 ? (
                  _.filter(answers, (answer) => {
                    return answer.type === category;
                  }).map((answer) => (
                    <form
                      className={classes.form}
                      key={answer.id}
                      noValidate
                      autoComplete="off"
                    >
                      <label className={classes.dotlabel}>•</label>
                      <Typography
                        className={
                          !!highlights.find((x) => x === answer.id)
                            ? classes.highlighterCorrect
                            : classes.highlighterWrong
                        }
                      >
                        {answer.item}
                      </Typography>
                    </form>
                  ))
                ) : (
                  <div>No Answer</div>
                )}
              </>
            ) : (
              <>
                {contents.length > 0 ? (
                  contents.map((content) => (
                    <form
                      className={classes.form}
                      key={content.id}
                      noValidate
                      autoComplete="off"
                    >
                      <Typography
                        className={
                          content.result
                            ? classes.highlighterCorrect
                            : classes.highlighterWrong
                        }
                      >
                        {content.item}
                      </Typography>
                    </form>
                  ))
                ) : (
                  <div>No Answer</div>
                )}
              </>
            )}
          </div>
        </div>
      </>
    );
  };
  return display();
};
